var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "setting-field" },
      [
        _c("el-badge", { staticClass: "label" }, [
          _c("label", [_vm._v(" Subscription ")]),
        ]),
        _vm._v(" "),
        _c("el-switch", {
          attrs: { disabled: true },
          on: { change: _vm.onTriggersSubscriptionChange },
          model: {
            value: _vm.triggersSubscription,
            callback: function ($$v) {
              _vm.triggersSubscription = $$v
            },
            expression: "triggersSubscription",
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.triggersSubscription ? "on" : "off"))]),
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", [_vm._v("Triggers")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "setting-field" },
      [
        _c("el-badge", { staticClass: "label" }, [
          _c("label", [_vm._v(" Trigger ")]),
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            attrs: { placeholder: "Select Trigger", size: "small" },
            on: { change: _vm.onTriggerChange },
            model: {
              value: _vm.selectedTriggerId,
              callback: function ($$v) {
                _vm.selectedTriggerId = $$v
              },
              expression: "selectedTriggerId",
            },
          },
          _vm._l(_vm.triggers, function (trigger) {
            return _c("el-option", {
              key: trigger.id,
              attrs: { label: trigger.name, value: trigger.id },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("el-badge", { staticClass: "label" }, [
          _c("label", [_vm._v(" Name ")]),
        ]),
        _vm._v(" "),
        _c("el-input", {
          attrs: {
            size: "small",
            placeholder: "Name",
            disabled: !_vm.selectedTriggerId,
            "inline-message": "true",
          },
          model: {
            value: _vm.selectedTriggerNew.name,
            callback: function ($$v) {
              _vm.$set(_vm.selectedTriggerNew, "name", $$v)
            },
            expression: "selectedTriggerNew.name",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-container" },
          [
            _c(
              "el-button",
              {
                staticStyle: { "font-weight": "400" },
                attrs: {
                  type: "success",
                  size: "small",
                  disabled: !_vm.selectedTriggerId,
                },
                on: {
                  click: function ($event) {
                    return _vm.saveCurrentTrigger()
                  },
                },
              },
              [_vm._v("\n        Save\n      ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "font-weight": "400" },
                attrs: {
                  type: "danger",
                  size: "small",
                  disabled: !_vm.selectedTriggerId,
                },
                on: {
                  click: function ($event) {
                    return _vm.deleteCurrentTrigger()
                  },
                },
              },
              [_vm._v("\n        Delete\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", [_vm._v("States")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "setting-field" },
      [
        _c("el-badge", { staticClass: "label" }, [
          _c("label", [_vm._v(" State ")]),
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            attrs: {
              placeholder: "Select State",
              disabled: !_vm.selectedTriggerId,
              size: "small",
            },
            on: { change: _vm.onStateChange },
            model: {
              value: _vm.selectedStateId,
              callback: function ($$v) {
                _vm.selectedStateId = $$v
              },
              expression: "selectedStateId",
            },
          },
          _vm._l(_vm.states, function (state) {
            return _c("el-option", {
              key: state.id,
              attrs: { label: state.name, value: state.id },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("el-badge", { staticClass: "label" }, [
          _c("label", [_vm._v(" Name ")]),
        ]),
        _vm._v(" "),
        _c("el-input", {
          attrs: {
            size: "small",
            placeholder: "Name",
            disabled: !_vm.selectedStateId,
            "inline-message": "true",
          },
          model: {
            value: _vm.selectedStateNew.name,
            callback: function ($$v) {
              _vm.$set(_vm.selectedStateNew, "name", $$v)
            },
            expression: "selectedStateNew.name",
          },
        }),
        _vm._v(" "),
        _c("el-badge", { staticClass: "label" }, [
          _c("label", [_vm._v(" Enabled ")]),
        ]),
        _vm._v(" "),
        _c("el-switch", {
          attrs: { disabled: !_vm.selectedStateId },
          model: {
            value: _vm.selectedStateNew.enabled,
            callback: function ($$v) {
              _vm.$set(_vm.selectedStateNew, "enabled", $$v)
            },
            expression: "selectedStateNew.enabled",
          },
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.selectedStateNew.enabled ? "on" : "off")),
        ]),
        _vm._v(" "),
        _c("el-badge", { staticClass: "label" }, [
          _c("label", [_vm._v(" Notification ")]),
        ]),
        _vm._v(" "),
        _c("el-switch", {
          attrs: { disabled: !_vm.selectedStateId },
          model: {
            value: _vm.selectedStateNew.notification,
            callback: function ($$v) {
              _vm.$set(_vm.selectedStateNew, "notification", $$v)
            },
            expression: "selectedStateNew.notification",
          },
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.selectedStateNew.notification ? "on" : "off")),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-container" },
          [
            _c(
              "el-button",
              {
                staticStyle: { "font-weight": "400" },
                attrs: {
                  type: "success",
                  size: "small",
                  disabled: !_vm.selectedStateId,
                },
                on: {
                  click: function ($event) {
                    return _vm.saveCurrentState()
                  },
                },
              },
              [_vm._v("\n        Save\n      ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "font-weight": "400" },
                attrs: {
                  type: "danger",
                  size: "small",
                  disabled: !_vm.selectedStateId,
                },
                on: {
                  click: function ($event) {
                    return _vm.deleteCurrentState()
                  },
                },
              },
              [_vm._v("\n        Delete\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }